'use strict';

angular.module('myApp')


.controller('HeaderCtrl', ['$window','$location','$scope', '$timeout', '$rootScope',function($window, $location, $scope, $timeout, $rootScope) {

    $rootScope.link='/fatafat'
	if(localStorage.getItem('userLocation')) {
        $rootScope.userLocation = localStorage.getItem('userLocation');
        $scope.$on('$routeChangeStart', function($event, next, current) {
            console.log("<><><",current)
        //    url.indexOf('/fatafat')
              console.log("><><><>>loction",$location.path())
              var url = $location.path()
             
              var a = url.indexOf('/rides') ;
            var b =  url.indexOf('/fatafat');
            var nofound = url.indexOf('/404')
			if(url.indexOf('/sg')!= -1)
				$rootScope.show_singapore_footer = true;
			else
				$rootScope.show_singapore_footer = false;
           if(a!=-1||b!=-1 || nofound!=-1 || url.indexOf('/not-available')!= -1){
            $scope.showlocation= true
            // $scope.$apply();
           }
           else{
            $scope.showlocation=false;
            // $scope.$apply();
           }
                 });



       //var geocoder = new google.maps.Geocoder();
       // if (geocoder) {
       //     geocoder.geocode({
       //         'address': $rootScope.userLocation
       //     }, function (results, status) {
       //         if (status == google.maps.GeocoderStatus.OK) {
       //             if (results[0]) {
       //                 localStorage.setItem('lat',results[0].geometry.location.lat())
       //                 localStorage.setItem('long',results[0].geometry.location.lng())
       //
       //                 //find country name
       //                 for (var i=0; i<results[0].address_components.length; i++) {
       //                     for (var b=0;b<results[0].address_components[i].types.length;b++) {
       //
       //                         //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
       //                         if (results[0].address_components[i].types[b] == "locality") {
       //                             //this is the object you are looking for
       //                             if ($scope.city.long_name.toLowerCase() == "bengaluru") {
       //                                 $scope.city.long_name = "banglore";
       //                             }
       //                             else if ($scope.city.long_name.toLowerCase() == "gurugram") {
       //                                 $scope.city.long_name = "gurgaon";
       //                             }
       //                             else if($scope.city.long_name.toLowerCase() == "panchkula" || $scope.city.long_name.toLowerCase() == "kharar" || $scope.city.long_name.toLowerCase() == "zirakpur" || $scope.city.long_name.toLowerCase() == "mohali"|| $scope.city.long_name.toLowerCase() == "sahibzada ajit singh nagar" || $scope.city.long_name.toLowerCase() == "landran" ) {
       //                                 $scope.city.long_name = "chandigarh";
       //                             }
       //                             $scope.city= results[0].address_components[i];
       //
       //                             if ($scope.city.long_name.toLowerCase() == "bengaluru") {
       //                                 $scope.city.long_name = "banglore";
       //                             }
       //                             else if ($scope.city.long_name.toLowerCase() == "gurugram") {
       //                                 $scope.city.long_name = "gurgaon";
       //                             }
       //                             else if($scope.city.long_name.toLowerCase() == "panchkula" || $scope.city.long_name.toLowerCase() == "kharar" || $scope.city.long_name.toLowerCase() == "zirakpur" || $scope.city.long_name.toLowerCase() == "mohali"|| $scope.city.long_name.toLowerCase() == "sahibzada ajit singh nagar" || $scope.city.long_name.toLowerCase() == "landran" ) {
       //                                 $scope.city.long_name = "chandigarh";
       //                             }
       //
       //                             $rootScope.link='/fatafat/' + $scope.city.long_name.toLowerCase().replace(' ', '-');
       //
       //                             break;
       //                         }
       //                     }
       //                 }
       //             }
       //
       //         }
       //     });
       // }



    }

	//else {
    //
     //       if (navigator.geolocation) {
     //           navigator.geolocation.getCurrentPosition(function (position) {
    //
     //               var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
     //               var geocoder = new google.maps.Geocoder();
     //               geocoder.geocode({
     //                   'location': latlng
     //               }, function (results, status) {
     //                   if (status === 'OK') {
     //                       if (results[1]) {
     //                           //formatted address
    //
     //                           $rootScope.userLocation = results[1].formatted_address;
     //                           localStorage.setItem('userLocation' , $rootScope.userLocation);
     //                          console.log("dewrewewrrewrewrewrewrewrewrewradaa",results)
    //
     //                           for (var i=0; i<results[0].address_components.length; i++) {
     //                               for (var b=0;b<results[0].address_components[i].types.length;b++) {
    //
     //                                   //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
     //                                   if (results[0].address_components[i].types[b] == "administrative_area_level_2") {
     //                                       //this is the object you are looking for
     //                                       var cityroute = results[0].address_components[i].long_name;
    //
     //                                       if (cityroute.toLowerCase() == "bengaluru") {
     //                                           cityroute = "banglore";
     //                                       }
     //                                       else if (cityroute.toLowerCase() == "gurugram") {
     //                                           cityroute = "gurgaon";
     //                                       }
     //                                       else if(cityroute.toLowerCase() == "panchkula" || cityroute.toLowerCase() == "kharar" || cityroute.toLowerCase() == "zirakpur" || cityroute.toLowerCase() == "mohali"|| cityroute.toLowerCase() == "sahibzada ajit singh nagar" || cityroute.toLowerCase() == "landran") {
     //                                           cityroute = "chandigarh";
     //                                       }
    //
     //                                       $rootScope.link='/fatafat/' + cityroute.toLowerCase().replace(' ', '-');
     //                                       $scope.$digest();
     //                                       break;
    //
     //                                   }
     //                               }
     //                           }
    //
     //                       }
     //                   }
     //               });
     //           });
     //       } else {
    //
     //           var message = "Geolocation is not supported by this browser.";
    //
     //       }
    //
	//}



    /*$scope.$on('$locationChangeStart', function(event) {
        jQuery(function($) {
            var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
            $('.nav li a ').each(function() {
                if (path.indexOf(this.href) !== -1) {

                    $(this).addClass('activator');
                }
                else{
                    $(this).removeClass('activator');

                }
            });
        });
    });


*/


	$scope.CheckScreenSize = function(){
           console.log($(window).width())
		if($(window).width() < 1023){
			document.getElementById('headerDropdown').classList.add('openClass');

		}else
		{
			document.getElementById('headerDropdown').classList.remove('openClass');
		}
    }
    $scope.collapse = function() {
        var element = document.getElementById("demo");
  element.classList.remove("in");
    }
   	$scope.logout = function() {
        $window.localStorage.clear();
        $rootScope.showName = false;
        if(typeof(window.shutDownFugu()) == 'function') {
            window.shutDownFugu();
        }
        $location.path('/');
    }

    $(document).on('click','.navbar-collapse.in',function(e) {
        if( $(e.target).is('a') ) {
            $(this).collapse('hide');
        }
    });

    $scope.animate = function (action) {
      var element = document.getElementById('baner')
      if(action === "show") {
        element.style.left = "0px"
      }
      if(action ==="hide") {
        element.style.left = "-380px"  
      }
    }
    

	/* $scope.cityList = [
            
         {
		"city_id": "11",
		"city_name": "Ahmedabad",
         "url":"/fatafat/ahmedabad/restaurants"
	    },  
        {
		"city_id": "31",
		"city_name": "Bhopal",
         "url":"/fatafat/bhopal/restaurants"
	     }, 
         {
		"city_id": "22",
		"city_name": "Bhubaneswar",
         "url":"/fatafat/bhubaneswar/restaurants"
	     },     
            
        {
		"city_id": "1",
		"city_name": "Chandigarh",
        "url":"/fatafat/chandigarh/restaurants"
	    }, 
         {
		"city_id": "25",
		"city_name": "Coimbatore",
         "url":"/fatafat/coimbatore/restaurants",
	     }, 
            {
		"city_id": "9",
		"city_name": "Delhi",
         "url":"/fatafat/delhi/restaurants"
	    },
              {
		"city_id": "28",
		"city_name": "Faridabad",
         "url":"/fatafat/faridabad/restaurants"
	    }, 
            
         {
		"city_id": "7",
		"city_name": "Gurgaon",
         "url":"/fatafat/gurgaon/restaurants"
	    }, 
         {
		"city_id": "20",
		"city_name": "Guwahati",
         "url":"/fatafat/guwahati/restaurants"
	     }, 
         {
		"city_id": "18",
		"city_name": "Hyderabad",
         "url":"/fatafat/hyderabad/restaurants"
	    },    
         {
		"city_id": "8",
		"city_name": "Indore",
         "url":"/fatafat/indore/restaurants"
	    },
         {
		"city_id": "4",
		"city_name": "Jaipur",
         "url":"/fatafat/jaipur/restaurants"
	    }, 
         {
		"city_id": "19",
		"city_name": "Jodhpur",
         "url":"/fatafat/jodhpur/restaurants"
	     },  
          {
		"city_id": "24",
		"city_name": "Kota",
         "url":"/fatafat/kota/restaurants",
	      },
         {
		"city_id": "33",
		"city_name": "Lucknow",
         "url":"/fatafat/lucknow/restaurants"
	     },    
        {
		"city_id": "2",
		"city_name": "Ludhiana",
         "url":"/fatafat/ludhiana/restaurants"
	    },
         {
		"city_id": "46",
		"city_name": "Madurai",
         "url":"/fatafat/madurai/restaurants"
       
         },
       
        
        {
		"city_id": "12",
		"city_name": "Nagpur",
         "url":"/fatafat/nagpur/restaurants"
	    },
         {
		"city_id": "16",
		"city_name": "Nasik",
         "url":"/fatafat/nasik/restaurants"
	    },  
         {
		"city_id": "17",
		"city_name": "Noida",
         "url":"/fatafat/noida/restaurants"
	    },
           
        {
		"city_id": "13",
		"city_name": "Pune",
         "url":"/fatafat/pune/restaurants"
	    }, 
         {
		"city_id": "15",
		"city_name": "Surat",
         "url":"/fatafat/surat/restaurants"
	    },  
          {
		"city_id": "23",
		"city_name": "Udaipur",
         "url":"/fatafat/udaipur/restaurants",
	     },     
        {
		"city_id": "14",
		"city_name": "Vadodara",
         "url":"/fatafat/vadodara/restaurants"
	    }];
		*/

 

	

	
}])
